export const PAGE = 'resetPassword';
export const FORM = 'resetPassword';
